<template>
  <div class="home">
    <div class="home-container" v-if="m === null || !isMobile">
      <NotFound v-if="fetched && is404" :data="data"></NotFound>
      <div class="home-nav">
        <AppHeader
          v-if="restored && !is404"
          :isLogin="isLogin"
          :isMyHome="isMyHome"
          :isEditMode="isEditMode"
          @clickSignup="m = 'signup'"
          @clickSignupMp="clickSignupMp"
          @clickResetPassword="m = 'reset-password'"

          @clickSignin="clickSigninFromNav"
          @clickSigninMp="clickSigninMp"
          @clickSignout="logout"

          @clickShare="m = 'share'"
          @clickEdit="clickEdit"
          @clickInbox="clickInbox"
          @clickAvatar="clickAvatar"
        ></AppHeader>
      </div>
      <div v-if="!fetched || !is404" class="home-header"></div>
      <!-- 主体页面 -->
      <User v-if="fetched && data && !is404"
        :data="data"
        :config="config"
        :isShowBasicInfo="isShowWhenModalShow"
        :isShowUserDesc="isShowWhenModalShow"
        :isShowUserModule="isShowWhenModalShow"
        :isShowUserSetting="isShowWhenModalShow"

        :isShowSend="isShowSend"
        :isEditMode="isEditMode"

        @clickSend="clickSend"
        @clickEditUser="m='edit-user'"
        @clickEditUserDesc="m='edit-user-desc'"
        @clickEditModule="clickEditModule"

        @commitUserHeadImage="commitUserHeadImage"
        @commitUserSetting="commitUserSetting"
      ></User>

      <AppFooter v-if="isShowFooter && fetched && !is404"></AppFooter>
      <div v-if="wxmpDebug">
        <input placeholder="wxmpInput.method" v-model="wxmpInput.method" />
        <input placeholder="wxmpInput.signupUrl" v-model="wxmpInput.signupUrl" />
        <input placeholder="wxmpInput.loginUrl" v-model="wxmpInput.loginUrl" />
      </div>
      <div :style="footerBlankStyle"></div>
    </div>

    <wx v-if="fetched && isWeChat"
      :debug="debug"
      :title="shareTitle"
      :desc="shareDesc"
      :imgUrl="shareImgUrl"
      @updateWx="updateWx"></wx>

    <!-- auth -->
    <SignupModal v-if="m === 'signup'"
      :error="error"
      @close="closeModal"
      @commit="commitSignin"
      @signin="m = 'signin'"
      @update:error="updateError"></SignupModal>
    <ResetPasswordModal v-if="m === 'reset-password'"
      :error="error"
      :isNutsbp="isNutsbp"
      @close="closeModal"
      @commit="commitResetPassword"
      @signin="m = 'signin'"
      @corner="m = 'weixin-qrcode'"
      @update:error="updateError"></ResetPasswordModal>
    <SigninModal v-if="m === 'signin'"
      :error="error"
      :isNutsbp="isNutsbp"
      @close="closeModal"
      @commit="commitSignin"
      @reset="m = 'reset-password'"
      @signup="m = 'signup'"
      @corner="m = 'weixin-qrcode'"
      @update:error="updateError"></SigninModal>
    <WeixinQrcodeModal v-if="m === 'weixin-qrcode'"
      :error="error"
      @close="closeModal"
      @commit="commitSignin"
      @reset="m = 'reset-password'"
      @signup="m = 'signup'"
      @corner="m = 'signin'"
      @update:error="updateError"></WeixinQrcodeModal>
    <QrcodeModal v-if="m === 'qrcode'" @close="closeModal"></QrcodeModal>
    <ConfirmModal v-if="m === 'home'"
      :lang="{
        close: '留在原地',
        commit: '前往主页'
      }"
      @close="closeModal"
      @commit="goHome"
    >当前页面不是你的个人主页，请选择是否前往您的个人主页</ConfirmModal>

    <!-- share -->
    <BrowserShareCover v-if="m === 'share' && isMobile && !isWeChat && !isChrome"
      @click="closeModal"></BrowserShareCover>
    <WeixinShareCover v-if="m === 'share' && isMobile && (isWeChat || isChrome)"
      @click="closeModal"></WeixinShareCover>
    <WeixinShareCover
      v-if="m==='share-me'" text="吸引更多优秀项目投递，传播个人品牌"
      @click="closeModal"
    >
    </WeixinShareCover>

    <!-- sendbp -->
    <SendBpModal v-if="m==='sendbp'" :data="data"
      @close="closeModal"
      @create="clickCreateBp"
    >
    </SendBpModal>
    <MessageModal v-if="m==='download-mobile'" @close="closeModal">
      <div class="download-mobile">
        <div class="download-mobile-body">
          <div class="download-mobile-body-center">
            <div>你好，手机Web版暂不支持投递</div>
            <div>
              <span>你可以到PC版投递：</span><a @click="clickToPc">www.nutsbp.com</a>
            </div>
            <div>或到应用商店下载疯狂BP</div>
          </div>
        </div>
        <div v-if="isShowDownloadButton" class="download-mobile-footer">
          <BaseButton2 class="download-mobile-footer-button" @click="clickDownload">前往商店下载</BaseButton2>
        </div>
        <div v-if="!isShowDownloadButton" class="download-mobile-footer">
          <BaseButton2 class="download-mobile-footer-button" :type="2" @click="closeModal">确定</BaseButton2>
        </div>
      </div>
    </MessageModal>

    <!-- <MessageModal v-if="m==='share-me'" @close="closeModal">
      <div class="download-mobile">
        <div class="download-mobile-body">
          <div class="download-mobile-body-center">
            <div>点击分享，传播个人品牌，提高个人影响力</div>
          </div>
        </div>
        <div class="download-mobile-footer">
          <BaseButton1 class="download-mobile-footer-button" @click="clickShareMp">分享</BaseButton1>
        </div>
      </div>
    </MessageModal> -->

    <!-- edit -->
    <EditUserModal
      v-if="m==='edit-user' && !isMobile"
      :data="data"
      @close="closeModal"
      @commit="commitUser"
    >
    </EditUserModal>

    <EditUserPage v-if="m==='edit-user' && isMobile" :data="data"
      @close="closeModal"
      @back="closeModal"
      @commit="commitUser"
      @wxmp="wxmp"></EditUserPage>

    <EditUserDescModal v-if="m==='edit-user-desc' && !isMobile" :data="data"
      @close="closeModal"
      @commit="commitUserDesc"></EditUserDescModal>
    <EditUserDescPage v-if="m==='edit-user-desc' && isMobile" :data="data"
      @close="closeModal"
      @back="closeModal"
      @commit="commitUserDesc"></EditUserDescPage>

    <EditTextModal v-if="m==='md-text'" :data="editData" :config="config"
      @close="closeEdit"
      @commit="commitEditModule"></EditTextModal>

    <EditListModal v-if="m==='md-list' && !isMobile" :data="editData" :config="config"
      @close="closeEdit"
      @commit="commitEditModule"></EditListModal>
    <EditListPage v-if="m==='md-list' && isMobile" :data="editData" :config="config"
      @close="closeEdit"
      @back="closeEdit"
      @commit="commitEditModule"></EditListPage>

    <EditCaseModal v-if="m==='md-case' && !isMobile" :data="editData" :config="config"
      @close="closeEdit"
      @commit="commitEditModule"></EditCaseModal>
    <EditCasePage  v-if="m==='md-case' && isMobile" :data="editData" :config="config"
      @close="closeEdit"
      @back="closeEdit"
      @commit="commitEditModule"></EditCasePage>

    <EditTalkModal v-if="m==='md-talk'" :data="editData" :config="config"
      @close="closeEdit"
      @commit="commitEditModule"></EditTalkModal>
  </div>
</template>

<script>
import _ from 'lodash'
import {
  formatError,
  formatUserModule
} from '@/util.js'
import defaultMdList from './defaultMdList.js'

import wx from '@/wx.vue'
import {
  SignupModal,
  WeixinQrcodeModal,
  ResetPasswordModal,
  SigninModal,
  QrcodeModal,
  ConfirmModal,
  BrowserShareCover,
  WeixinShareCover,
  EditUserModal,
  EditUserDescModal,
  EditTextModal,
  EditListModal,
  EditCaseModal,
  EditTalkModal,
  EditUserPage,
  EditUserDescPage,
  EditListPage,
  EditCasePage,
  SendBpModal,
  MessageModal,
  BaseButton2
} from '@/components'
import {
  User,
  Header as AppHeader,
  Footer as AppFooter,
  NotFound
} from '@/containers'

export default {
  components: {
    wx,
    //
    SignupModal,
    WeixinQrcodeModal,
    ResetPasswordModal,
    SigninModal,
    QrcodeModal,
    ConfirmModal,
    BrowserShareCover,
    WeixinShareCover,
    EditUserModal,
    EditUserDescModal,
    EditTextModal,
    EditListModal,
    EditCaseModal,
    EditTalkModal,
    EditUserPage,
    EditUserDescPage,
    EditListPage,
    EditCasePage,
    SendBpModal,
    MessageModal,
    BaseButton2,
    //
    User,
    AppHeader,
    AppFooter,
    NotFound
  },
  data () {
    let stageSrc = ['种子', '天使轮', 'Pre-A', 'A轮', 'B轮', 'C轮', 'D轮', 'Pre-IPO', 'IPO']
    return {
      m: null,
      isLocked: false,
      isLogin: false,
      isNutsbp: false,
      isMyHome: false,
      isEditMode: false,
      restored: false,
      pullerTriggered: false,
      fetched: false,
      error: null, // 共用 response error payload
      data: null,
      config: {
        stageSrc,
        stage: stageSrc.map(row => {
          return {
            label: row,
            value: row
          }
        }),
        industry: []
      },
      needInit: false,
      wxmpInput: {
        // DO NOT use redirectTo or reLaunch, it's not work in real device
        method: this.$route.query.wxmpMethod || 'navigateTo',
        signupUrl: this.$route.query.wxmpSignup ? decodeURIComponent(this.$route.query.wxmpSignup) : '/pages/index?type=signup',
        loginUrl: this.$route.query.wxmpLogin ? decodeURIComponent(this.$route.query.wxmpLogin) : '/pages/index?type=login'
      },
      editData: null,
      editIndex: -1
    }
  },
  computed: {
    /** @see https://doc.nutsb.com/#/dartcome/pr.f2e */
    debug () { return this.$store.state.debug },
    wxmpDebug () { return this.$route.query.hasOwnProperty('wxmpDebug') },
    isMobile () { return this.$store.getters.isMobile },
    isChrome () { return this.$store.getters.isChrome },
    isWeChat () { return this.$store.getters.isWeChat },
    is404 () { return _.get(this.data, 'pr_state') !== 1 },
    isShowMenu () { return this.$route.query.menu !== 'hide' }, // Show menu bar
    isShowSend () { return this.$route.query.send !== 'hide' }, // Show delivery button
    isShowShareMe () { return this.$route.query.hasOwnProperty('share-me') }, // Show share button
    isShowDownloadButton () { return !this.$route.query.hasOwnProperty('nodl') },
    isShowFooter () { return this.$route.query.footer !== 'hide' },
    isShowWhenModalShow () { // 防止手機上 modal 背景可以 scroll
      if (!this.isMobile) { // 非手機永遠都 show
        return true
      }
      if (
        this.m !== null &&
        this.m !== 'download-mobile' &&
        this.m !== 'share-me'
      ) {
        return false
      }
      return true
    },
    pageAccount () { return this.$store.getters.pageAccount },
    footerBlankStyle () {
      if (!this.$route.query.fheight) {
        return ''
      }
      return `width:100%;height:${this.$route.query.fheight}`
    },
    shareTitle () {
      let name = _.get(this.data, 'card.name', this.pageAccount)
      return `向${name}投递BP`
    },
    shareDesc () {
      let rList = []
      let title = _.get(this.data, 'card.title')
      if (title) {
        rList.push(`${title}`)
      }
      let labels = []
      labels = _.get(this.data, 'user_module[0].value[0].value', [])
        .map(k => {
          let o = _.find(this.config.industry, {value: k})
          if (o) {
            return o.label
          }
          return null
        })
        .filter(row => row)
      if (labels.length > 0) {
        rList.push(`投资阶段: ${labels.join('/')}`)
      }
      labels = _.get(this.data, 'user_module[0].value[1].value', [])
        .map(k => {
          let o = _.find(this.config.industry, {value: k})
          if (o) {
            return o.label
          }
          return null
        })
        .filter(row => row)
      if (labels.length > 0) {
        rList.push(`关注领域: ${labels.join('/')}`)
      }
      if (rList.length <= 0) {
        return location.origin + location.pathname
      }
      return rList.join(', ')
    },
    shareImgUrl () {
      let url = _.get(this.data, 'card.head_image_url')
      if (url) {
        return url
      }
      return 'https://az.cdn.nutsbp.com/007/image/nuts_dartcome/phone/pr/cut_page/pr_phone_logo.png'
    }
  },
  methods: {
    updateWx (wx) { this.wx = wx },
    closeModal () {
      this.m = null
      this.error = null
    },
    updateError (e) {
      this.error = formatError(e)
      if (e) {
        console.error('updateError', 'e', e, this.error)
      }
    },
    /**
     * TODO: Move this logic to store
     * Login dartcome
     */
    async afterRestoreDartcome (data) {
      this.$store.commit('me/me', data)
      const uuid = _.get(data, 'uuid')
      if (uuid === _.get(this.data, 'uuid')) {
        this.isMyHome = true
      }
      this.isLogin = true

      this.saveTokenByAuthData(data)
      if (this.isMyHome) {
        // this.isEditMode = true
        if (this.needInit) {
          await this.$store.dispatch('me/createInitialModule')
        }
      }
    },
    async afterRestoreNutsbp (data) {
      this.$store.commit('me/cardinfo', data)
      this.saveTokenByAuthData(data)
    },
    /**
     * TODO: Move this logic to store
     * Login dartcome
     */
    async saveTokenByAuthData (data) {
      if (data && data['.session_id']) {
        let sessionId = data['.session_id']
        this.$store.dispatch('set', {
          path: 'sid',
          value: sessionId
        })
      }
      if (data && data['.u']) {
        let u = data['.u']
        this.$store.commit('me/u', u)
      }
    },

    /**
     * Login dartcome and nutsbp
     */
    async restore () {
      try {
        let data = await Promise.all([
          this.$store.dispatch('api/dartcome/v1Me'),
          this.$store.dispatch('api/nutsbp/me')
        ])
        this.afterRestoreDartcome(data[0])
        this.afterRestoreNutsbp(data[1])
      } catch (e) {
        console.error(e) // restore 失敗不需提示
      } finally {
        this.restored = true
      }
    },

    logout () { this.$store.dispatch('me/logout') },
    async commitResetPassword (input) {
      let validate = await this.$validator.validateAll(input)

      if (!validate) {
        this.error = this.errors.all()[0]
        return
      }
      try {
        await this.$store.dispatch('api/ranch/userResetPassword', {
          uid: input.phone,
          password: input.password,
          smsCode: input.code
        })
        this.m = 'signin'
      } catch (e) {
        this.updateError(e)
      }
    },
    async commitSignin (input) {
      let validate = await this.$validator.validateAll(input)

      if (!validate) {
        this.error = this.errors.all()[0]
        return
      }
      try {
        await this.$store.dispatch('api/ranch/userSignIn', {
          type: 1,
          uid: input.username,
          password: input.password
        })
        return window.location.reload()
      } catch (e) {
        this.updateError(e)
      }
    },
    goHome () { window.location.href = this.$store.getters['me/homeUrl'] },
    clickSend () {
      if (this.isShowShareMe) {
        this.m = 'share-me'
        return
      }
      if (this.isMobile) {
        this.m = 'download-mobile'
        return
      }
      if (this.isLogin) {
        this.m = 'sendbp'
        return
      }
      this.clickSignin()
      // this.m = 'nutsbp-login'
    },
    clickEdit () {
      if (!this.isLogin || !this.isMyHome) {
        // this.m = 'home'
        this.goHome()
        return
      }
      this.isEditMode = !this.isEditMode
    },
    clickInbox () {
      window.open(`https://${this.$store.getters.baseDomain}`, '__blank')
    },
    clickAvatar () { console.log('clickAvatar') },
    clickShareMp () {
      if (this.wx && this.wx.miniProgram) {
        wx.miniProgram.postMessage({ api: 'showShareMenu' })
      } else {
        console.error('wx.miniProgram not fount')
      }
    },
    clickSignupMp () {
      let method = this.wxmpInput.method
      let url = this.wxmpInput.signupUrl
      this.wxmp(method, { url })
    },
    // clickSigninFromSendbpButton () {
    //   this.isNutsbp = true
    //   this.clickSignin()
    // },
    clickSigninFromNav () {
      this.isNutsbp = false
      this.clickSignin()
    },
    clickSignin () {
      if (this.restored) {
        this.m = 'weixin-qrcode'
      }
    },
    clickSigninMp () {
      let method = this.wxmpInput.method
      let url = this.wxmpInput.loginUrl
      this.wxmp(method, { url })
    },
    clickCreateBp () {
      let url
      if (this.isMobile) {
        url = this.$store.getters.downloadUrl
      } else {
        url = `${this.$store.getters.editorUrl}/lobby?u=${this.$store.state.me.u}`
      }
      window.open(url, '__blank')
    },
    clickToPc () { window.open('https://www.nutsbp.com', '_blank') },
    clickDownload () { window.open('https://download.nutsbp.com', '_blank') },
    clickEditModule (row, i) {
      this.editData = row
      this.editIndex = i
      this.m = row.type
    },
    wxmp (method, opts) {
      if (this.wx && this.wx.miniProgram) {
        console.log(`wx.miniProgram.${method}`, opts)
        this.wx.miniProgram[method](opts)
      } else {
        console.error('wx.miniProgram not found')
      }
    },
    closeEdit () {
      this.closeModal()
      this.editData = null
      this.editIndex = -1
    },
    /**
     * Initialize app
     */
    async fetch () {
      try {
        let data = null

        if (window.__data) {
          data = _.get(window.__data, 'user[0]')
          await this.$store.dispatch('api/dartcome/setUser', data)
        } else if (this.pageAccount) {
          data = await this.$store.dispatch('api/dartcome/user', {
            account: this.pageAccount
          })
        }
        console.error('Write data in model')

        if (!data) {
          throw new Error(`data not found (${this.pageAccount})`)
        }

        console.error('Get industry')
        if (this.config.industry.length <= 0) {
          this.config.industry = await this.$store.dispatch('api/conf/fixedIndustry')
        }

        console.error('Check user module')
        if (
          !data.user_module ||
          !Array.isArray(data.user_module) ||
          data.user_module.length <= 0
        ) {
          data.user_module = _.cloneDeep(defaultMdList)
          this.needInit = true
          console.error('Patch user modules')
        } else {
          data.user_module = formatUserModule(data.user_module, this.config)
        }
        // replace by deliverFinish
        // let qaCount = await this.$store.dispatch('api/ranch/deliverQaSends', {
        //   user: _.get(data, 'uuid')
        // })
        // data.investor.qaCount = qaCount
        console.error(data)
        console.error(JSON.stringify(data))
        this.data = data
      } catch (e) {
        console.error('fetch', 'e', e)
      } finally {
        this.fetched = true
        console.error(`fetched: ${this.fetched}`)
        console.error(`is404: ${this.is404}`)
      }
    },
    /**
     * Commit to user information
     * @param {object} input The input data
     * @param {objec<file>} input.img  The head image file
     * @param {string}      input.name The user's name
     * @param {string}      input.title The user's title
     * @param {string}      input.city The user's city
     * @param {string}      input.province The user's province
     */
    async commitUser (input) {
      if (this.isLocked) {
        return
      }
      try {
        this.isLocked = true
        // TODO No need ?
        if (input.img) {
          await this.uploadUserHeadImage(input.img)
        }
        await this.$store.dispatch('api/dartcome/updateUser', {
          name: input.name,
          title: input.title,
          city: input.city,
          province: input.province
        })
        this.closeModal()
      } catch (e) {
        console.error('commitUser', 'e', e)
      } finally {
        this.isLocked = false
      }
    },
    /**
     * Commit to update user's head image
     * @param {object<event>} event The DOM event to upload file
     */
    async commitUserHeadImage (event) {
      let file = event.target.files[0]
      await this.uploadUserHeadImage(file)
    },
    async uploadUserHeadImage (file) {
      let data = await this.$store.dispatch('api/dartcome/updateUserHeadImage', {file})
      if (this.isMyHome) {
        this.updateMe({
          card: {
            head_image_url: _.get(data, 'card.head_image_url')
          }
        })
      }
      return data
    },
    async commitUserDesc (input) {
      if (this.isLocked) return
      try {
        this.isLocked = true
        await this.$store.dispatch('api/dartcome/updateUser', {
          profile: input.profile
        })
        this.closeModal()
      } catch (e) {
        console.error('commitUserDesc', 'e', e)
      } finally {
        this.isLocked = false
      }
    },
    async commitUserSetting (input) {
      if (this.isLocked) {
        return
      }
      try {
        this.isLocked = true
        let inputFixed = {
          deliverPrice: input.qa_price * 100,
          state: input.enable_sendbp ? 0 : 1 // 0 正常 1 不可投遞
        }
        await this.$store.dispatch('api/ranch/investorUsave', inputFixed)
        this.updateUser({
          investor: inputFixed
        })
      } catch (e) {
        console.error('commitUserSetting', 'e', e)
      } finally {
        this.isLocked = false
      }
    },
    async commitEditModule (input) {
      if (this.isLocked) return
      try {
        const { type, id } = this.editData
        await this.$store.dispatch('api/dartcome/updateUserModule', { id, type, input })
        this.closeModal()
      } catch (err) {
        console.error('commitEditModule', 'e', err)
      } finally {
        this.isLocked = false
      }
      // try {
      //   this.isLocked = true
      //   let type = null
      //   let data = null
      //   switch (this.editData.type) {
      //     case 'md-list':
      //       type = 'preference'
      //       data = {
      //         stage: _.get(input, '[0].value', []),
      //         field: _.get(input, '[1].value', []),
      //         amount: _.get(input, '[2].value', [0, 0])
      //       }
      //       break
      //     case 'md-case':
      //       type = 'case'
      //       data = input.map(row => {
      //         return {
      //           name: row.name,
      //           desc: row.value,
      //           industry: row.label,
      //           logo: row.logo
      //         }
      //       })
      //       break
      //     default:
      //       return
      //   }
      //   if (this.editData.hasOwnProperty('id')) {
      //     await this.$store.dispatch('api/dartcome/updateUserModule', {
      //       id: this.editData.id,
      //       type,
      //       data
      //     })
      //   } else {
      //     await this.$store.dispatch('api/dartcome/createUserModule', { type, data })
      //     // let id = _.get(data, 'id'))
      //     // TODO update module id
      //   }
      //   this.updateModule(this.editIndex, input)
      //   this.closeModal()
      // } catch (e) {
      //   console.error('commitEditModule', 'e', e)
      // } finally {
      //   this.isLocked = false
      // }
    },

    startGlobalPulling (interval = 15000) {
      let handleId = setTimeout(async () => {
        try {
          let data = await this.pullUserDataForWxmpUpdate()
          this.updateUser(data)
        } catch (e) {
          console.error('startGlobalPulling', 'e', e)
        }
        clearTimeout(handleId)
        this.startGlobalPulling(interval)
      }, interval)
    },
    async pullUserDataForWxmpUpdate () {
      if (!this.pageAccount) {
        return null
      }
      let data = await this.$store.dispatch('api/dartcome/user', {
        type: 1,
        account: this.pageAccount
      })
      return data
    },

    updateUser (partial) {
      _.merge(this.data, partial)
      if (document) {
        // this format must same as server render
        // see src/Util.js userToTitle
        document.title = _.get(this.data, 'card.name', '') + ' ' + _.get(this.data, 'card.title', '') + ' | 大咖'
      }
    },
    updateMe (partial) {
      this.$store.commit('me/mergeCardinfo', partial)
    },
    updateModule (i, partial) {
      // this.data.user_module[i].value = _.merge(this.data.user_module[i].value, partial)
      this.data.user_module[i].value = partial
    }
  },
  watch: {
    isMyHome (newValue, oldValue) {
      if (!newValue) {
        this.m = 'home'
      }
    }
  },
  // created () {
  //   this.$validator.attach({name: 'username', rules: 'required|regex:^.{11}$', alias: '手机号'})
  //   this.$validator.attach({name: 'password', rules: 'required|min:6|max:16', alias: '密码'})
  //   this.$validator.attach({name: 'code', rules: 'required|min:6|max:6', alias: '验证码'})
  // },
  async mounted () {
    console.log(`App ready!`)
    let newQuery = { ...this.$route.query }
    let sid = newQuery.sid
    if (sid) {
      this.$store.dispatch('set', {
        path: 'sid',
        value: sid
      })
      delete newQuery.sid
      this.$router.push({
        name: 'home',
        query: newQuery
      })
    }
    console.log(`Fetch data`)
    await this.fetch()

    // User login
    console.log(`Check user login`)
    if (this.isShowSend || this.isShowMenu) {
      await this.restore()
    }

    if (
      !this.pullerTriggered &&
      this.$route.query.hasOwnProperty('pull')
    ) {
      let interval = 15000
      if (this.$route.query.hasOwnProperty('pull-ms')) {
        let parsed = parseInt(this.$route.query['pull-ms'])
        if (Number.isFinite(parsed)) {
          interval = parsed
        } else {
          console.error(`invalid pull-ms: ${this.$route.query['pull-ms']}, using default ${interval}`)
        }
      }
      this.startGlobalPulling(interval)
      this.pullerTriggered = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="postcss" scoped>
@import "var.css";
.home {
  & .home-nav {
    position: relative;
    max-width: 1024px;
    margin: auto;
  }
  & .home-header {
    background-image: url('https://az.cdn.nutsbp.com/007/image/nuts_dartcome/pc/pr/cut_page/pr_page_top_bar.png');
    background-size: cover;
    background-position: center;
    @media (--mediaPc) {
      height: 230px;
    }
    @media (--mediaMobile) {
      height: calc(230px / var(--scaleMobile));
    }
  }
}
.download-mobile {
  & .download-mobile-body {
    position: relative;
    text-align: center;
    color: var(--colorGray0);

    @media (--mediaPc) {
      font-size: var(--textSize3);
    }
    @media (--mediaMobile) {
      font-size: var(--textSize3Mobile);
    }
    & .download-mobile-body-center {
      @media (--mediaPc) {
        padding: 58px 0;
        margin: 0 58px;
      }
      @media (--mediaMobile) {
        padding: calc(58px / var(--scaleMobile)) 0;
        margin: 0 calc(58px / var(--scaleMobile));
      }
    }
    &::before {
      content: '';
      width: 0;
      height: 100%;
      display: inline-block;
      position: relative;
      vertical-align: middle;
    }
  }
  & .download-mobile-footer {
    text-align: center;
    @media (--mediaPc) {
      bottom: 36px;
    }
    @media (--mediaMobile) {
      bottom: calc(36px / var(--scaleMobile));
    }
    & .download-mobile-footer-button {
      @media (--mediaPc) {
        width: 100px;
        margin: 0 20px;
      }
      @media (--mediaMobile) {
        width: calc(240px / var(--scaleMobile));
        margin: 0 calc(32px / var(--scaleMobile) / 2);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/HomePage.vue